<template>
<!-- eslint-disable max-len -->
<span>
  <transition enter-active-class="animated slideInDown" leave-active-class="animated fadeOut">
    <div class="report-container" id="report-container">
      <div :class="`report ${pdf ? 'pdf' : ''}`" ref="report" id="report">
        <div :class="`report-header ${pdf ? 'pdf' : ''}`">
          <div
            class="no-wrap"
            style="
              font-size: 1.3em;
            "
          >
            SGM Gamulation
          </div>
          <!-- title -->
          <div class="report-title no-wrap">{{activeEnvironment.reportTitle || game.reportTitle || 'Report'}}</div>
          <div
            class="no-wrap"
            style="
              font-size: 1.3em;
            "
          >
            {{username}}
          </div>
        </div>

        <!-- divider -->
        <div
          class="primarybox"
          style="
            height: 1px;
            margin: 0 26px;
          "
        >
        </div>

        <!-- subtitle/date -->
        <div
          style="
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            padding: 4px 26px;
            font-size: 1.1em;
          "
        >
          <div class="no-wrap">
            Question review
          </div>
          <div class="no-wrap">
            {{date}}
          </div>
        </div>

        <!-- questions / correctness -->
        <div
          v-for="(q, i) of questions"
          :key="`q${i}`"
          style="
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            padding: 4px 26px;
            font-size: 1.17em;
            height: 60px;
          "
        >
          <div
            style="
              display: flex;
              flex-flow: row nowrap;
              justify-content: flex-start;
              align-items: center;
              width: 94%;
              background-color: white;
              border: 1px solid grey;
            "
          >
            <div
              style="
                width: 4%;
                margin: 0 1%;
                text-align: center;
              "
            >{{i + 1}}.</div>
            <div
              style="
                width: 94%;
                line-height: 110%;
              "
            >{{q.question}}</div>
          </div>
          <div
            style="
              width: 5%;
              background-color: white;
              border: 1px solid grey;
              display: flex;
              flex-flow: row nowrap;
              justify-content: center;
              align-items: center;
            "
          >
            <!-- checkmark based on correctness -->
            <div
              v-if="q.correct"
              style="
                height: 90%;
                width: 90%;
                background-image: url('/static/reports/SGM_report_Checkmark.png');
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
              "
            ></div>
            <div
              v-else
              style="
                height: 90%;
                width: 90%;
                background-image: url('/static/reports/SGM_report_X.png');
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
              "
            ></div>
          </div>
        </div>

        <!-- dividing header -->
        <div
          class="secondarybox"
          style="
            margin: 4px 26px;
            padding: 4px 24px;
            font-size: 1.2em;
          "
        >
          Further information and resources on caring for LGBTQ+ youth, adolescents and adults:
        </div>

        <!-- static bulleted info -->
        <div
          style="
            display: flex;
            flex-flow: column nowrap;
            margin: 4px 26px;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="infobullet">
            <div class="chainlink"></div> <!-- link image -->
            <div class="infotext"><a href="https://www.lgbtqiahealtheducation.org/" target="_blank" class="emph">The National LGBTQIA+ Health Education Center</a> has abundant resources including videos, modules, publications, webinars, and toolkits related to all aspects of health care. <a href="https://www.lgbtqiahealtheducation.org/glossary/" target="_blank" class="emph">The Glossary of Terms</a> is particularly helpful.</div>
          </div>
          <div class="infobullet">
            <div class="chainlink"></div> <!-- link image -->
            <div class="infotext"><a href="https://www.thetrevorproject.org/resources/" target="_blank" class="emph">The Trevor Project Resource Center</a> covers physical and mental health issues for LGBTQ+ young people including how to signal you are an ally, a Coming Out Handbook, resources for talking about suicidality, and current statistics/survey results.</div>
          </div>
          <div class="infobullet">
            <div class="chainlink"></div> <!-- link image -->
            <div class="infotext"><a href="https://out2enroll.org/" target="_blank" class="emph">Out2Enroll</a> is a national organization focused on connecting the LGBTQ community with health insurance resources and enrollment support.</div>
          </div>
          <div class="infobullet">
            <div class="chainlink"></div> <!-- link image -->
            <div class="infotext">The <a href="https://www.glma.org/" target="_blank" class="emph">GLMA: Health Professionals Advancing LGBTQ Equality</a> is the oldest association of LGBT healthcare professionals. Their organization is dedicated to the advancement of LGBT equality in healthcare for both individuals and healthcare professionals.</div>
          </div>
          <div class="infobullet">
            <div class="chainlink"></div> <!-- link image -->
            <div class="infotext"><a href="https://healthlgbtq.org/" target="_blank" class="emph">The National Coalition for LGBT Health</a> is committed to improving the health and well-being of lesbian, gay, bisexual and transgender individuals through federal and local advocacy, education, and research.</div>
          </div>
          <div class="infobullet">
            <div class="chainlink"></div> <!-- link image -->
            <div class="infotext"><a href="https://pflag.org/" target="_blank" class="emph">PFLAG</a> is the first and largest organization dedicated to supporting, educating, and advocating for LGBTQ+ people and their families.</div>
          </div>
          <div class="infobullet">
            <div class="chainlink" style="align-self: flex-end;"></div> <!-- link image -->
            <div style="width: 96%;">
              <div class="infotext">If you know someone who is thinking about suicide, please remember these resources:</div>
              <div class="infotext">Call 988, the 24-hour national suicide outline</div>
              <div class="infotext">The Trevor Project has a 24/7 suicide hotline for LGBTQ+ youth. You can call 866-488-7386 or text by sending "START" to 678-678 on your phone. You can also start a <a href="https://chat.trvr.org/" target="_blank" class="emph">chat on the Trevor Project website.</a></div>
            </div>
          </div>
        </div>

        <!-- footer -->
        <div
          v-if="pdf && (activeEnvironment.reportFooter || activeEnvironment.reportFooterLogo)"
          style="
            background-color: black;
            color: white;
            padding: 4px 50px;
            width: 100%;
            min-height: 36px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: flex-start;
          "
        >
          <!-- footer message (e.g. displaying ©) -->
          <div v-html="activeEnvironment.reportFooter"></div>
          <!-- footer logo -->
          <img
            v-if="activeEnvironment.reportFooterLogo"
            :src="resolveAssetPath(activeEnvironment.reportFooterLogo, 'ui/customer')"
            :class="`footer-logo ${pdf ? 'pdf' : ''}`"
            ref="footerLogo"
          >
        </div>
      </div>
    </div>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="showDownloading" class="download-message">Downloading!</div>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <button v-if="showNextButton"
      class="btn download-button"
      @click.prevent="onClickDownload"
    >Download</button>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <bottom-bar v-if="showNextButton" :next="showNarratorNotification ? onComplete : undefined" :tabindex="3" ref="bottomBar" :noBar="true">
      <span slot="button">
        <span v-html="(narrative && narrative.nextButtonText) ? narrative.nextButtonText : ((game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next')"></span>
      </span>
    </bottom-bar>
  </transition>
</span>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import JsPDF from 'jspdf';
import domtoimage from 'dom-to-image-more';

import Narrator from '../ui/Narrator';
import NarratorNotification from '../ui/NarratorNotification';
import BottomBar from '../ui/BottomBar';

export default {
  // $emit 'input' on complete
  components: {
    Narrator,
    NarratorNotification,
    BottomBar,
  },
  data() {
    return {
      showNextButton: false,
      showDownloading: false,
      showNarrator: false,
      showNarratorNotification: false,
      pdf: false,
      questions: [],
      info: [
        'The',
        'The',
        'Out2Enroll',
        'The',
        'The',
        'PFLAG',
        'If',
      ],
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'activeClass',
      'characters',
      'tooltip',
      'narrative',
      'lastNarrative',
      'nextNarrative',
      'narrativeNavbarText',
      'narrativeText',
      'group',
      'me',
      'metrics',
      'game',
      'dateActiveGameCompleted',
      'challenge'
    ]),
    username() {
      const {
        firstName = '',
        lastName = '',
        email = ''
      } = this.me || {};
      return firstName || lastName ? `${firstName} ${lastName}` : email;
    },
    date() {
      return (this.game.carryOverMetricsFromActive && this.dateActiveGameCompleted != null)
        ? new Date(this.dateActiveGameCompleted).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        : ((this.challenge && this.challenge.completed)
          ? new Date(this.challenge.completed).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
          : ((this.group && this.group.updated)
            ? new Date(this.group.updated).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
            : new Date(Date.now()).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })));
    },
    reportFileName() {
      return (this.activeClass != null && this.activeClass.studentReportFileName != null)
        ? this.activeClass.studentReportFileName
        : (this.activeEnvironment.reportTitle || this.game.reportTitle || 'Report');
    },
    logo() {
      return this.activeEnvironment.reportLogo || this.activeEnvironment.creditsLogo || this.activeEnvironment.titleLogo;
    },
  },
  methods: {
    ...mapActions([
      'stopSounds',
      'getMyGroup'
    ]),
    async show() {
      this.showNarrator = true;
      await Vue.nextTick();
      this.stopSounds();
      await new Promise(resolve => setTimeout(resolve, 1250));
      this.showNarratorNotification = true;
      await new Promise(resolve => setTimeout(resolve, 1250));
      await Vue.nextTick();
    },
    async reset() {
      await Vue.nextTick();
      await this.show();
    },
    navigate() {
      this.$refs.bottomBar.navigate();
    },
    async onComplete() {
      if (this.tooltip && this.tooltip.preventStateProgressionWhileOpen) {
        window.dispatchEvent(new Event('click'));
        return;
      }
      this.$emit('input');
    },
    async loadPageData() {
      try {
        const { _id: groupId } = this.group;
        await this.getMyGroup({ groupId });
      } catch (err) {
        if (await this.$router.handleGameError(err)) return;
        this.$router.showGameErrorCritical();
      }
    },
    setStats() {
      console.log(this.group);
      // TODO: the following order-dependent coupling is not ideal, but it currently seems
      //       to be the best way to do this given the way the data is currently organized.
      //       An ID-based coupling or a name-based coupling seems similarly dicey,
      //       and they'd just be costlier to compute.

      if (this.group && this.group.metrics && this.group.metrics.length > 18) {
        [2, 3, 4, 5, 6, 7, 8, 10, 12, 13, 14, 15, 16, 18].forEach((index) => {
          const gMetric = this.group.metrics[index];
          if (gMetric && gMetric._id) {
            const metric = this.metrics[gMetric._id];
            if (metric && metric.title) {
              this.questions.push({
                question: metric.title.replace(/^Q\d+:/, ''),
                correct: gMetric.value === 0,
              });
            }
          }
        });
      }
    },
    onBeforePrint(mql) {
      if (mql instanceof Event) {
        this.pdf = true;
        setTimeout(() => {
          this.pdf = false;
        }, 250);
      } else if (mql.matches) {
        this.pdf = true;
        setTimeout(() => {
          this.pdf = false;
        }, 250);
      }
    },
    iOS() {
      const platform = navigator.platform || navigator.userAgentData.platform;
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    },
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    async onClickDownload() {
      if (this.showDownloading) return;
      this.showDownloading = true;
      // PDF download works in all browsers except pre-chromium Edge
      // (fails at domtoimage.toPng, and no replacement seems viable, see above)
      // fix for Edge (for now): make the page printable, and open the print dialog automatically
      // (in response to domtoimage.toPng or any other part of the autodownload throwing any error)
      // The user can print to PDF or actually print. Bonus is you can print in other browsers too.
      // Edge requires the user to manually set the Scale in the print dialog to 50% for it to fit.
      // Note that this is generally no longer a problem with the new chromium-based Edge.
      this.pdf = true;
      try {
        await Vue.nextTick();
        await new Promise((resolve, reject) => {
          if (this.$refs.footerLogo && this.$refs.footerLogo.complete) { // wait for logo to load
            resolve();
          } else if (this.$refs.footerLogo) {
            this.$refs.footerLogo.addEventListener('load', resolve);
            this.$refs.footerLogo.addEventListener('error', reject);
          } else {
            console.log('No footerLogo ref found');
            resolve();
          }
        });
        let dataUrl = await domtoimage.toPng(this.$refs.report, { cacheBust: true });
        // redundant calls required to work on Safari... (https://github.com/tsayen/dom-to-image/issues/343)
        const brokenBecauseSafari = this.iOS() || this.isSafari();
        if (brokenBecauseSafari) {
          dataUrl = await domtoimage.toPng(this.$refs.report);
          dataUrl = await domtoimage.toPng(this.$refs.report);
        }
        const doc = new JsPDF('p', 'pt', 'a4');
        doc.addImage(dataUrl, 'PNG', 28, 50, 540, 747);

        // TODO: if no autodownload, no soft-lock (explained below), so soft-lock fix commented out
        doc.save(`${this.reportFileName}.pdf`);
        // Before we download the PDF, we have to consider the possibility that the
        // user's settings are set to view the PDF in the browser first when downloading a PDF
        // (instead of actually downloading it). This can be true in many modern browsers.
        // This is a problem because if it opens in the same page, it destroys the Vue app state.
        // This ends up soft-locking the player such that they can't get past the report page.
        // This problem came to my attention when a Firefox update changed the PDF download behavior
        // to default to viewing it in browser (on the same page) when you initiate a download.
        // To fix this while minimally impacting anyone whose browser actually just downloads stuff
        // when a download is initiated, instead first open a new tab, then artificially initiate
        // the download with a bogus DOM hyperlink element that targets the bloburl output by JsPDF,
        // which either downloads the file or loads the blob viewer. If it doesn't load the
        // blob viewer, we autoclose the tab, leaving you back on the report page. If it does load
        // the blob viewer, the user is left in the blob viewer, where they can either:
        // - close it, returning to the original report tab without downloading, where they can
        //   hit print or refresh to save off the report another way, or continue on with the game.
        // - download/print it (which presents a system dialog, and does carry over the expected
        //   default name) (and then close it to return back to the game).
        // eslint-disable-next-line max-len
        // const win = window.open(`${window.location.origin}/downloadplayerreport/${encodeURIComponent(this.reportFileName)}/${encodeURIComponent(doc.output('bloburl', { filename: `${this.reportFileName}.pdf` }))}`, '_blank');
        // if (win == null) {
        //   doc.save(`${this.reportFileName}.pdf`);
        // }

        this.pdf = false;
        this.showDownloading = false;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to download report PDF!', error);
        try {
          this.pdf = true;
          this.selectedTab = 0;
          await Vue.nextTick();
          window.print();
          this.pdf = false;
          this.showDownloading = false;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('Failed to open print dialog!', e);
          this.pdf = false;
          this.showDownloading = false;
          this.selectedTab = 0;
        }
      }
    },
  },
  watch: {
    async narrative(newValue) {
      if (newValue) await this.reset();
    },
  },
  async mounted() {
    this.setStats();

    // polyfill for safari but works for others as well
    const mediaQueryList = (window.matchMedia != null) ? window.matchMedia('print') : null;
    if (mediaQueryList != null && mediaQueryList.addListener != null) {
      mediaQueryList.removeListener(this.onBeforePrint);
      mediaQueryList.addListener(this.onBeforePrint);
    } else {
      // what you'd normally use, if you weren't needing to support Safari:
      window.removeEventListener('beforeprint', this.onBeforePrint);
      window.addEventListener('beforeprint', this.onBeforePrint);
    }

    await this.show();

    // uncomment to enable autodownload (but re-add soft-lock fix above if you do)
    // await this.onClickDownload();

    this.showNextButton = true;
  },
};
</script>

<style lang="scss" scoped>
@media print {
  body, body * {
    visibility: hidden !important;
    overflow: visible !important;
  }
  #report-container, #report-container * {
    visibility: visible !important;
    overflow: visible !important;
  }
  #report-container {
    left: 8.75% !important;
    top: 0 !important;
    width: 82.5% !important;
    overflow: visible !important;
    z-index: 10 !important;

    // this makes background graphics show up without needing to check the box
    color-adjust: exact !important;
    print-color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
  }
}

.no-wrap {
  white-space: nowrap;
}

.download-button {
  position: absolute;
  bottom: 210px;
  right: 0;
  width: 350px;
  font-size: 28px;
  line-height: 55px;
  margin-right: 45px;
  z-index: 100 !important;
  transition: opacity 0.5s ease-in-out;
}

hr {
  border-top: 1px solid #e9ecef;
}
.report {
  background-color: #dddddd;
  color: black;
  border: solid;
  border-width: 24px;
  border-color: var(--secondaryColor);
}
// .report.pdf {
// }
.report-container {
  position: absolute;
  width: 1150px;
  height: 850px;
  top: 20px;
  left: 30px;
  z-index: 1;
  overflow: auto;
}

.report-header {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-end;
  height: 48px;
  padding: 4px 26px;
}
.report-title {
  font-size: 2.1em;
  white-space: pre-wrap;
  text-align: right;
  max-width: 60%;
  max-height: 100%;
  line-height: 100%;
}
.footer-logo {
  object-fit: contain;
  max-height: 30px;
  max-width: 30%;
  margin-bottom: 15px;
  z-index: 10;
}

.primarybox {
  background-color: var(--primaryColor);
  color: white;

  color-adjust: exact;
  -webkit-print-color-adjust: exact;
}

.secondarybox {
  background-color: var(--secondaryColor);
  color: white;

  color-adjust: exact;
  -webkit-print-color-adjust: exact;
}

.infobullet {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 8px;
}

.chainlink {
  height: 29px;
  width: 29px;
  margin: 0 4px;
  background-image: url('/static/reports/SGM_report_link.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.infotext {
  width: 96%;
  white-space: pre-wrap;
  font-size: 0.99em;
  color: black;
}

.emph {
  font-weight: 600;
  font-size: 1.03em;
  color: var(--primaryColor);
}

// https://stackoverflow.com/a/31633969/10747078
br {
  display: block;
  content: '';
  margin-top: 0.95em;
}

.slideInDown {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1); // out expo
}
.fadeOutUp {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); // in cubic
}
.narrator-notification {
  bottom: 205px;
}

.download-message {
  position: absolute;
  top: 50%;
  left: 25%;
  z-index: 1000;
  border-radius: 15px;
  border: 3px solid black;
  background-color: var(--primaryColor);
  color: white;
  font-size: 30pt;
  padding: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/game/narrative/NarrativeReportSGM.vue